export default __webpack_public_path__ + "static/media/next_calendar.a664dc61.svg";